import React, {useContext, useEffect} from 'react';
import ClienteDirectoContext from '../../context/ClienteDirectoContext';
import './Landing.css';
import {Companies} from "./Companies";
import {Producer} from "./Producer";
import {Products} from "./Products";
import {Banner} from "./Banner";

const Landing = () => {

    const {activeProducts, companiesIdDict} = useContext(ClienteDirectoContext);

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
    }, [])

    const companiesId = Array.from(
        new Set(
            Object.values(activeProducts)
                .flatMap(product => product['codigos_aseguradoras'])
                .map(el => el['id_aseguradora'])
        )
    );
    const companiesName = companiesId.map(company => companiesIdDict[company])

    return (
            <div className='Landing__container'>
                <Banner/>
                <Products/>
                <Companies activeCompanies={companiesName}/>
                <Producer/>
            </div>
    )
}

export default Landing;